import React, {Component} from "react";
import NRTVerticalStack from "../../../components/_common/_containers/VerticalStack";
import NRTTextInput from "../../../components/_common/_controlled-inputs/TextInput";
import createConnectedInput from "../../../redux/actions-reducers/form/create-connected-input";
import {FORM_REGISTRATION} from "../../../redux/actions-reducers/form-registration/reducer";

const InputCpf = createConnectedInput(FORM_REGISTRATION)('cpfCnpj', NRTTextInput)
const InputName = createConnectedInput(FORM_REGISTRATION)('name', NRTTextInput)
const InputEmail = createConnectedInput(FORM_REGISTRATION)('email', NRTTextInput)
const InputCelular = createConnectedInput(FORM_REGISTRATION)('phoneOne', NRTTextInput)
const InputPassword = createConnectedInput(FORM_REGISTRATION)('password', NRTTextInput)
const InputConfirmPassword = createConnectedInput(FORM_REGISTRATION)('confirmPassword', NRTTextInput)

export class FormCompleteRegistration extends Component {

    render() {

        const num = /[0-9]/

        return (
            <NRTVerticalStack>
                <InputCpf label={'CPF*'}
                          mask={[num, num, num, '.', num, num, num, '.', num, num, num, '-', num, num]}
                />

                <InputName label={'Nome*'}/>

                <InputEmail label={'E-mail*'}/>

                <InputCelular label={'Celular*'}
                              mask={['(', num, num, ')', num, num, num, num, num, '-', num, num, num, num]}

                />

                <InputPassword label={'Senha*'} type="password"/>

                <InputConfirmPassword label={'Confirmar senha*'} type="password"/>

            </NRTVerticalStack>
        )

    }

}




// WEBPACK FOOTER //
// ./src/_pages/CompleteRegistration/organisms/FormCompleteRegistration.js